function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "1.3,65.422 10.027,65.054 14.502,59.105 13.57,46.465 19.698,41.444 26.764,42.375 36.801,50.745  50.559,49.252 64.504,52.046 64.127,54.46 67.104,55.764 69.331,54.833 75.096,56.688 75.096,60.037 80.298,57.62 77.695,53.905  73.8,37.728 73.431,30.854 74.725,29.361 78.264,32.711 80.298,29.361 84.766,30.294 87.364,27.503 89.225,33.45 94.431,35.875  92.191,40.521 92.752,42.748 89.225,48.325 95.355,49.807 94.795,54.46 98.887,52.971 105.024,44.237 119.152,40.521  119.152,39.029 121.751,38.658 126.963,30.294 129.559,33.08 130.49,37.169 133.658,37.728 136.633,47.962 144.623,43.682  161.348,66.359 164.883,66.91 167.479,70.997 179.747,76.209 184.221,80.297 181.434,98.884 184.957,104.464 186.81,121.002  191.092,122.862 194.623,132.159 200,134.02 200,137.359 196.112,148.895 193.325,152.606 187.744,153.915 189.792,158.555  185.518,163.204 181.434,164.138 179.747,171.939 178.078,172.497 169.718,163.758 164.322,164.138 119.152,154.467 106.697,146.47  105.957,143.688 44.236,120.08 43.499,115.985 22.86,103.91 20.068,98.329 16.541,98.884 0.361,80.297 "
});

var Svg12 = function Svg12(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GRO",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg12, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/12.595c1570.svg";
export { ForwardRef as ReactComponent };